import { createContext } from 'react';

const BranchesContext = createContext({
  allBranches: [],
  branchesCount: 0,
  isLoading: true,
});

export default BranchesContext;
